import { render } from "./NewReceiverType.vue?vue&type=template&id=3e615552&scoped=true&ts=true"
import script from "./NewReceiverType.vue?vue&type=script&lang=ts"
export * from "./NewReceiverType.vue?vue&type=script&lang=ts"

import "./NewReceiverType.vue?vue&type=style&index=0&id=3e615552&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e615552"]])

export default __exports__